import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';
import axios from 'axios';

 
const NewsDetailItems = () => { 


          const { t, i18n } = useTranslation();
          const currentLanguage = i18n.language; // Aktif dili alıyoruz

      const { id } = useParams();
        const [news, setNews] = useState([])
      const [singleNews, setSingleNews] = useState("")
      const [isLoading, setIsLoading] = useState(true)


      useEffect(() => {
              getProducts();
            }, []);
          
            const getProducts = async () => {
              try {
                const response = await axios.get(
                  `https://cortex-site.runasp.net/api/Blogs`,
                  { withCredentials: false }
                );
                console.log(response.data);
                setNews(response.data);
                const filteredNews = response.data.find(product => product.id == id);
               setSingleNews(filteredNews);
               setIsLoading(false)
              } catch (error) {
                console.error("Error fetching products:", error);
              }
            };

             const getLocalizedField = (item, fieldBase) => {
    if (!item) return "";
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

            if (!singleNews) return <div className='pt-[88px] md:pt-[104px] bg-[#F9F9F9] text-center py-10'>Loading...</div>;


  return (
    <div className='pt-[56px] md:pt-[88px] bg-[#F9F9F9]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className='md:flex justify-between'>
          <div className='md:w-[65%] text-[#1C1C1C]'>
    <p className='text-[26px] font-medium'> {getLocalizedField(singleNews, 'title')}</p>
<p className='mt-6'>
                  {getLocalizedField(singleNews, 'description').replace(/<[^>]*>/g, '')}
                </p>

          </div>
          <div className='md:w-[30%] mt-10 md:mt-0'>
          <div className="relative w-full">
             <img src={`https://cortex-site.runasp.net/${singleNews.image}`} className='w-full rounded-[12px]' alt='' />
             {/* <span className='absolute top-3 right-3 text-[#2a3d63] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
               {singleNews?.date}
             </span> */}
           </div>
          </div> 
        </div>
        <div className='flex justify-between items-center mt-[104px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>{t("Digər bloqlar")}</p>
       <a className='hidden md:block group' href={`/${currentLanguage}/blogs`}>
                             <div className='flex justify-between items-center w-[164px] rounded-[12px] bg-[#fbfbfb] text-[#1C1C1C] h-[46px] px-2'>
                                 <p className="transition-colors duration-300 group-hover:text-[#2a3d63]">{t("Hamısına bax")}</p>
                                    <img
                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                      src={rightArrow}
                                      alt=""
                                    />
                                    <img
                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                      src={rightArrowHover}
                                      alt=""
                                    />
                              </div>
                             </a>
        </div>
       <div className='grid grid-cols-1 md:grid-cols-4 gap-5 mt-[32px]'>
        {news?.slice(0, 4).map((item) => (
         <a key={item.id} href={`/${currentLanguage}/blogs/${item.id}`}>
         <div className='group overflow-hidden rounded-lg'>
           <div className="relative">
             <img src={`https://cortex-site.runasp.net/${item.image}`} className='w-full transition-transform duration-300 group-hover:scale-105' alt='' />
             {/* <span className='absolute top-3 right-3 text-[#2a3d63] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
               {item?.date}
             </span> */}
           </div>
           <p className='mt-3 text-[#1C1C1C]'> {getLocalizedField(item, 'title').replace(/<[^>]*>/g, '').slice(0, 80)}...</p>
         </div>
       </a>
            ))}
             <a className='block md:hidden' href={`/${currentLanguage}/blogs`}>
                             <div className='flex justify-between mx-auto items-center w-[144px] rounded-[12px] bg-[#fbfbfb] text-[#1C1C1C] h-[46px]'>
                                <p>{t("Hamısına bax")}</p>
                                <img className='w-2' src={rightArrow}></img>
                              </div>
                             </a>


    </div>
       </div>
    </div>
  )
}

export default NewsDetailItems